module.exports = __webpack_public_path__ + "static/media/iso.c8e0008c.svg";